import{jsx as o}from"react/jsx-runtime";import{Persona as r,getPersonaInitialsColor as t}from"@fluentui/react";export{PersonaCoin,PersonaInitialsColor,PersonaSize,getPersonaInitialsColor}from"@fluentui/react";const e=e=>o(r,{...e,initialsColor:t({text:e.id})});export{e as Persona};
//# sourceMappingURL=Persona.js.map
